  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyDWY3fhkDxdDJ0011Si6CH3lULCTCnBUnw",
  authDomain: "gentinupps.firebaseapp.com",
  projectId: "gentinupps",
  storageBucket: "gentinupps.firebasestorage.app",
  messagingSenderId: "862279306073",
  appId: "1:862279306073:web:d27599bf69cb3625859a48",
  measurementId: "G-SX8V3H0J6L"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
